import NewBudgetItem from "../Common/NewBudgetItem";

export default function NewExpense() {
  return <NewBudgetItem itemType="expense" />;
}
